import { OccConfig } from '@spartacus/core';

export const priceMediasOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        loadPriceMedia: '/users/current/prices-medias/loadPriceMedia',
        getPriceMedias: '/users/current/prices-medias/search'
      } as any,
    },
  },
};
